import { combineReducers } from 'redux';
import articles from './articles.reducer';
import user from './user.reducer';
import targetUser from './targetUser.reducer';
import colors from './colors.reducer';
import comments from './comments.reducer';
import offset from './offset.reducer';
import loading from './loading.reducer';
import hasLoadMore from './hasLoadMore.reducer';
import signIn from './signIn.reducer';
import signUp from './signUp.reducer';
import setting from './setting.reducer';
import commentLoading from './commentLoading.reducer';

const rootReducer = combineReducers({
  user,
  colors,
  articles,
  comments,
  offset,
  loading,
  signIn,
  signUp,
  setting,
  hasLoadMore,
  commentLoading,
  targetUser,
});

export default rootReducer;
